export const authorizationMiddleware = async () => {
	const isLogged = useCookie('is_logged')

	if (!isLogged?.value) {
		return await navigateTo({ path: '/login' })
	}
}

export default defineNuxtRouteMiddleware(authorizationMiddleware)
